import { Helmet } from "react-helmet";
import { previewImage } from "../../constants";

// Containers
import { View } from "../../containers/view/View";

import styles from "./PrivacyPolicy.module.scss";

export const PrivacyPolicy: React.FunctionComponent = () => {
  return (
    <View>
      <Helmet>
        <title>Politika privatnosti | Agencija Spektar</title>
        <meta
          property="og:title"
          content="Politika privatnosti | Agencija Spektar"
        />
        <meta property="og:image" content={previewImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Agencija Spektar" />
      </Helmet>

      <View.Content>
        <div className={styles.content}>
          <h1>Politika privatnosti</h1>

          <p>
            Dobro došli na internet stranicu Agencije Spektar{" "}
            <a
              href="https://www.agencijaspektar.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.agencijaspektar.com
            </a>
            .
          </p>
          <p>
            Zaštita privatnosti i ličnih podataka korisnika naših usluga
            predstavlja važan dio našeg poslovanja. Lične podatke obrađujemo
            odgovorno, transparentno i u skladu sa važećim propisima Bosne i
            Hercegovine i Republike Srpske, kao i principima Opšte uredbe o
            zaštiti podataka Evropske unije (GDPR), gdje je primjenjivo.
          </p>
          <p>
            Ova Politika privatnosti objašnjava koje podatke prikupljamo, na
            koji način ih koristimo i koja prava imate u vezi sa obradom Vaših
            podataka.
          </p>

          <h2>1. Administrator podataka</h2>
          <p>Administrator ličnih podataka je:</p>
          <p>
            Agencija Spektar Miroslav Vukajlović s.p. Banja Luka
            <br />
            Bana Milosavljevića 8, 78000 Banja Luka, BiH
            <br />
            E-mail:{" "}
            <a href="mailto:info@agencijaspektar.com">
              info@agencijaspektar.com
            </a>
          </p>

          <h2>2. Koje podatke prikupljamo</h2>
          <p>
            U okviru pružanja usluga posredovanja pri zapošljavanju i
            upravljanja konkursnim procedurama, možemo prikupljati i obrađivati
            sljedeće podatke:
          </p>
          <ul>
            <li>ime i prezime,</li>
            <li>kontakt podatke (telefon, e-mail adresa, adresa stanovanja),</li>
            <li>podatke iz biografije (CV),</li>
            <li>podatke o obrazovanju, kvalifikacijama i radnom iskustvu,</li>
            <li>motivaciona pisma i preporuke,</li>
            <li>podatke dostavljene putem prijava na konkurse,</li>
            <li>komunikaciju ostvarenu putem e-maila ili kontakt forme,</li>
            <li>
              tehničke podatke o korištenju web stranice (IP adresa, tip
              uređaja, kolačići i slično).
            </li>
          </ul>
          <p>
            Molimo Vas da ne dostavljate posebne kategorije ličnih podataka
            (npr. zdravstvene podatke, politička ili vjerska uvjerenja), osim
            ukoliko to nije neophodno i izričito zahtijevano zakonom ili
            prirodom procesa zapošljavanja.
          </p>

          <h2>3. Svrha i pravni osnov obrade podataka</h2>
          <p>Vaše podatke obrađujemo u sljedeće svrhe:</p>
          <ul>
            <li>sprovođenje procesa selekcije i zapošljavanja,</li>
            <li>evidencija prijava na konkurse,</li>
            <li>
              kontaktiranje kandidata u vezi sa konkursima i poslovnim
              prilikama,
            </li>
            <li>unapređenje kvaliteta naših usluga,</li>
            <li>analiza korištenja web stranice i unapređenje funkcionalnosti,</li>
            <li>ispunjavanje zakonskih obaveza.</li>
          </ul>
          <p>Pravni osnov za obradu podataka može biti:</p>
          <ul>
            <li>Vaša saglasnost,</li>
            <li>legitimni interes Agencije Spektar,</li>
            <li>
              preduzimanje radnji prije zaključenja ugovora o radu ili poslovne
              saradnje,
            </li>
            <li>zakonske obaveze.</li>
          </ul>
          <p>
            Slanjem prijave kandidat daje saglasnost Agenciji Spektar za obradu
            i čuvanje podataka u svrhu sprovođenja procesa selekcije i budućih
            poslovnih prilika.
          </p>

          <h2>4. Koliko dugo čuvamo podatke</h2>
          <p>
            Lične podatke čuvamo samo onoliko dugo koliko je potrebno za
            ostvarenje svrhe zbog koje su prikupljeni.
          </p>
          <p>
            Podaci kandidata mogu se čuvati do 24 mjeseca od posljednje prijave
            ili ostvarene komunikacije, osim ukoliko kandidat ranije ne zatraži
            brisanje podataka ili povuče saglasnost.
          </p>
          <p>
            Nakon isteka navedenog perioda, podaci mogu biti obrisani ili
            anonimizovani, osim u slučajevima kada postoji zakonska obaveza
            njihovog daljeg čuvanja.
          </p>

          <h2>5. Ko ima pristup podacima</h2>
          <p>
            Pristup podacima imaju isključivo ovlašteni zaposleni Agencije
            Spektar i angažovana IT podrška, u obimu neophodnom za obavljanje
            poslovnih aktivnosti i održavanje sistema.
          </p>

          <h2>6. Dijeljenje podataka sa trećim licima</h2>
          <p>
            Agencija Spektar može dostaviti podatke kandidata poslodavcima koji
            su angažovali Agenciju Spektar radi sprovođenja procesa selekcije i
            zapošljavanja.
          </p>
          <p>
            Podaci se neće prodavati niti ustupati neovlaštenim trećim licima.
          </p>
          <p>U određenim slučajevima podaci mogu biti dostupni:</p>
          <ul>
            <li>pružaocima IT i hosting usluga,</li>
            <li>partnerima uključenim u realizaciju procesa selekcije,</li>
            <li>nadležnim institucijama kada to zahtijeva zakon.</li>
          </ul>
          <p>
            Sve treće strane imaju obavezu zaštite podataka u skladu sa važećim
            propisima.
          </p>

          <h2>7. Zaštita podataka</h2>
          <p>
            Agencija Spektar primjenjuje odgovarajuće tehničke i organizacione
            mjere zaštite kako bi spriječila neovlašten pristup, gubitak,
            zloupotrebu ili neovlašteno otkrivanje ličnih podataka.
          </p>

          <h2>8. Kolačići (Cookies)</h2>
          <p>
            Naša web stranica može koristiti kolačiće i slične tehnologije radi:
          </p>
          <ul>
            <li>pravilnog funkcionisanja stranice,</li>
            <li>analize posjećenosti,</li>
            <li>unapređenja korisničkog iskustva,</li>
            <li>prikazivanja relevantnog sadržaja.</li>
          </ul>
          <p>
            Korištenjem web stranice pristajete na upotrebu kolačića u skladu sa
            postavkama Vašeg internet pregledača.
          </p>

          <h2>9. Vaša prava</h2>
          <p>
            U skladu sa važećim propisima o zaštiti ličnih podataka, imate
            pravo da:
          </p>
          <ul>
            <li>zatražite pristup svojim podacima,</li>
            <li>zatražite ispravku netačnih ili nepotpunih podataka,</li>
            <li>zatražite brisanje podataka kada za to postoje uslovi,</li>
            <li>ograničite obradu podataka,</li>
            <li>uložite prigovor na obradu podataka,</li>
            <li>povučete prethodno datu saglasnost,</li>
            <li>
              podnesete pritužbu nadležnom organu za zaštitu podataka.
            </li>
          </ul>
          <p>
            Kandidat ima pravo da u svakom trenutku zatraži brisanje svojih
            podataka, nakon čega će Agencija Spektar bez nepotrebnog odlaganja
            pristupiti obradi zahtjeva, osim u slučajevima kada postoji zakonska
            obaveza daljeg čuvanja podataka.
          </p>
          <p>
            Za ostvarivanje svojih prava možete nas kontaktirati putem e-mail
            adrese:{" "}
            <a href="mailto:info@agencijaspektar.com">
              info@agencijaspektar.com
            </a>
          </p>

          <h2>10. Izmjene politike privatnosti</h2>
          <p>
            Agencija Spektar zadržava pravo izmjene ove Politike privatnosti
            radi usklađivanja sa zakonskim propisima, tehničkim promjenama ili
            unapređenjem usluga.
          </p>
          <p>Sve izmjene biće objavljene na ovoj stranici.</p>
          <p>
            <strong>Posljednja izmjena politike privatnosti: maj 2026.</strong>
          </p>
        </div>
      </View.Content>
    </View>
  );
};
